require(
    [
      'paramsObserver',
      'Favorites',
      'eventLogger'
    ],
    function
    (
      paramsObserver,
      Favorites,
      EventLogger
    ) {
      'use strict';

      function handleFavorites() {
        const locationSelect = document.querySelector('#marketId');
        const partner = Number(document.querySelector('#nhs_partnerID').value);
        const logger = new EventLogger();
        const favoritesParameters = {
          urlBase: '',
          partnerId: partner,
          marketId: locationSelect.value,
          logger: logger
        };
        const favs = new Favorites(favoritesParameters);
    
        favs.init();
      }

      handleFavorites();
      paramsObserver.subscribe('resultsLoaded', handleFavorites);
    }
  );
  
define("favoritesHandler", function(){});

